import React from "react";
import { Routes, Route, NavLink, useNavigate } from "react-router-dom";
import StatsBar from "./components/StatsBar";
import ManualTriggerPanel from "./components/ManualTriggerPanel";
import JobFeed from "./pages/JobFeed";
import KanbanBoard from "./pages/KanbanBoard";
import CoverLetterViewer from "./pages/CoverLetterViewer";

const navItems = [
  { to: "/job-hunter", label: "Feed", end: true },
  { to: "/job-hunter/kanban", label: "Kanban", end: false },
];

export default function JobHunterApp() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 overflow-x-hidden transition-colors">
      <header className="bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-3 sm:px-4 h-14 flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 min-w-0">
            <button
              onClick={() => navigate("/")}
              className="shrink-0 p-2 rounded-lg text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
              title="Back to ToolBox"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <div className="flex items-center gap-2 min-w-0">
              <div className="shrink-0 w-7 h-7 rounded-lg bg-brand-600 flex items-center justify-center">
                <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <span className="font-semibold text-gray-900 dark:text-white text-sm truncate hidden xs:block sm:block">
                Cloud Job Hunter
              </span>
            </div>
          </div>
          <nav className="shrink-0 flex gap-0.5 bg-gray-100 dark:bg-gray-800 rounded-lg p-0.5">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `px-4 py-1.5 rounded-md text-sm font-medium transition-all ${
                    isActive
                      ? "bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm"
                      : "text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-3 sm:px-4 py-4 space-y-3">
        <StatsBar />
        <ManualTriggerPanel />
        <Routes>
          <Route index element={<JobFeed />} />
          <Route path="kanban" element={<KanbanBoard />} />
          <Route path="cover-letter/:jobId" element={<CoverLetterViewer />} />
        </Routes>
      </main>
    </div>
  );
}
